<template>
  <container>
    <main class="mt-12">
        <div id="home"
             class="animate__animated animate__fadeInDown w-full mx-auto flex flex-col overflow-hidden-x">
          <content-component :order1lg="'order-2'" :order2lg="'order-1'" :order1sm="'order-1'" :order2sm="'order-2'">
            <template #slot1 >
              <h1 class="text-4xl font-bold w-full">
                <span class="text-blue-600 text-6xl">Fáscia</span> <br>
                Chega ao Brasil um tratamento inovador
              </h1>
              <p class="text-xl font-normal text-blue-600 mt-6">O que é o tratamento das fáscias?</p>
              <p class="text-xl font-normal mt-2">
                As fáscias consiste em aliviar dores e melhorar o movimento tratando a raiz e causa do problema, promovendo saúde e o equilíbrio muscular.
              </p>
              <div class="w-full lg:gap-x-4 flex flex-col lg:flex-row  justify-start mt-12">
                <primary-button title="Agende uma pré consulta gratuita"
                                link="https://api.whatsapp.com/send?phone=5546991166942&text=Ol%C3%A1%2C%20venho%20atrav%C3%A9s%20da%20p%C3%A1gina%20e%20gostaria%20de%20agendar%20uma%20pr%C3%A9-consulta%C2%A0gratuita">
                </primary-button>
              </div>
            </template>
            <template #slot2>
              <img src="../../public/fascias.webp" alt="Fáscias" width="906" height="900" class="rounded-md mt-12 lg:mt-0" loading="lazy">
            </template>
          </content-component>
        </div>
    </main>
  </container>
  <container>
    <fascia-component />
  </container>
  <container>
    <fascias-benefits />
  </container>
  <footer>
    <contact-form/>
    <footer-component />
  </footer>
</template>
<script>
import Container from "@/components/partials/Container.vue";
import FooterComponent from "@/components/Footer.vue";
import PrimaryButton from "@/components/buttons/PrimaryButton.vue";
import ContentComponent from "@/components/partials/Content.vue";
import FasciasWhatIs from "@/components/fascias/FasciasWhatIs.vue";
import FasciasBenefits from "@/components/fascias/FasciasBenefits.vue";
import ContactForm from "@/components/fascias/ContactForm.vue";

export default {
  name: 'FasciaView',
  components: {
    ContactForm,
    FasciasBenefits,
    FasciaComponent: FasciasWhatIs,
    ContentComponent, PrimaryButton,
    FooterComponent,
    Container,
  },
};
</script>